<template>
    <section class="register__widget-row date-of-birth">
        <label class="label">
            {{ $t('registerUsername.dateOfBirth') }}:

            <input v-model="dateOfBirth"
                :disabled="isDisabled"
                type="date"
                min="1900-01-01"
                :max="minimumAgeYear"
                :class="['label__input', { 'label__input--active': dateOfBirth }]"
            >
        </label>
    </section>
</template>

<script>
// Store
import {
    mapActions,
} from 'vuex';

// Locale Modules
import localStoreTypes from '@webapp/store/types.js';

export default {
    name: 'date-of-birth',
    props: {
        isDisabled: {
            type: Boolean,
            default: false,
        },
        prepopulatedDateOfBirth: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            dateOfBirth: '',
        };
    },
    computed: {
        minimumAgeYear() {
            const today = new Date();
            const minDate = new Date(today.setFullYear(today.getFullYear() - 18));

            return minDate.toISOString().substring(0, 10);
        },

        isDateOfBirthUnder18() {
            return this.dateOfBirth && new Date(this.dateOfBirth) <= this.date18YrsAgo;
        },

        date18YrsAgo() {
            const currentDate = new Date();

            currentDate.setFullYear(currentDate.getFullYear() - 18);

            return currentDate.setHours(24, 0, 0, 0);
        },
    },
    watch: {
        dateOfBirth: 'validateDateOfBirth',
    },
    mounted() {
        this.dateOfBirth = (this.prepopulatedDateOfBirth) ? this.prepopulatedDateOfBirth : '';
    },
    methods: {
        ...mapActions({
            setIsDOBValid: localStoreTypes.SET_IS_DATE_OF_BIRTH_VALID,
            setRegistration: localStoreTypes.SET_REGISTRATION,
        }),

        validateDateOfBirth(newValue) {
            if (newValue) {
                this.setIsDOBValid(this.isDateOfBirthUnder18);

                this.setRegistration([
                    {
                        property: 'dateOfBirth',
                        value: this.dateOfBirth,
                    },
                ]);
            }
        },
    },
};
</script>